var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "dayRangePopup",
        { hidden: !_vm.isVisible },
        { error: _vm.hasError },
      ],
    },
    [
      _c("div", { staticClass: "dayRangePopupContainer" }, [
        _c("div", { staticClass: "topTabs" }, [
          _c(
            "span",
            {
              ref: "headerTabs",
              class: ["tab", "tabLeft", { active: _vm.activeTab === "live" }],
              attrs: { tabindex: "0" },
              on: {
                click: _vm.switchTabs,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.switchTabs.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        Last Hours / Days\n      ")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              class: [
                "tab",
                "tabRight",
                { active: _vm.activeTab === "previous" },
              ],
              attrs: { tabindex: "0" },
              on: {
                click: _vm.switchTabs,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.switchTabs.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        Custom Date / Time\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.liveOptionsClass }, [
          _c(
            "ul",
            _vm._l(_vm.liveOptions, function (title, hours) {
              return _c(
                "li",
                {
                  attrs: { tabindex: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.selectRange(hours)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.selectRange(hours)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(hours > 0 ? "LAST" : "") +
                      "\n          "
                  ),
                  _c("span", { staticClass: "liveValue" }, [
                    _vm._v(_vm._s(title)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.previousTimeClass },
          [
            _c("time-picker", {
              staticClass: "time startTime",
              attrs: {
                label: "Start Time",
                hours: _vm.startTime.hours,
                minutes: _vm.startTime.minutes,
              },
              on: { "time-change": _vm.handleStartTimeChange },
            }),
            _vm._v(" "),
            _c("time-picker", {
              staticClass: "time",
              attrs: {
                label: "End Time",
                hours: _vm.endTime.hours,
                minutes: _vm.endTime.minutes,
              },
              on: { "time-change": _vm.handleEndTimeChange },
            }),
            _vm._v(" "),
            _c("day-range-picker", {
              key: _vm.updateKey,
              attrs: { availableHours: _vm.dialBackHours, value: _vm.dayRange },
              on: { "day-range-change": _vm.handleDayChange },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "applyButton btn btn-primary",
                on: { click: _vm.applyNewDate },
              },
              [_vm._v("Apply")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "errorMessage" }, [
          _vm._v(_vm._s(_vm.errorMessage)),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            class: [{ hidden: _vm.dialBackHours > 700 }],
            attrs: {
              href: "https://www.vyopta.com/product/cpm/how-to-buy/",
              target: "_blank",
            },
          },
          [_vm._m(0)]
        ),
      ]),
      _vm._v(" "),
      _c("popup-wrapper", { on: { "popup-mask-clicked": _vm.handleClose } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer" }, [
      _c("span", [_vm._v("Need more dial-back? ")]),
      _vm._v(" "),
      _c("span", { staticClass: "underline" }, [
        _vm._v("See Upgrade Options."),
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-question-circle-o pull-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }